module.exports = __webpack_public_path__ + "static/img/ZXYP7.9a2728cc.png";